var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"banners"},[_c('WelcomeBonus',{staticClass:"welcome_bonus"}),_c('FreeWheel',{staticClass:"free_wheel"})],1),_c('Games'),_c('History')],1)}
var staticRenderFns = []

export { render, staticRenderFns }